<template>
  <Mutation
    :mutation="mutation"
    :variables="variables"
    @done="onDone"
    @error="onError"
  >
    <template v-slot="{ mutate, loading }">
      <ValidationObserver
        ref="observer"
        tag="form"
        @submit.prevent="onSubmit(mutate)"
      >

          <div key="base" v-if="!isConfirming">
            <button v-if="!loading" class="focus:outline-none">
              <font-awesome-icon :icon="['far', 'trash-alt']" class="text-blue-300"/>
            </button>
            <div v-else>
              <font-awesome-icon v-show="loading" class="ml-2" :icon="['far', 'spinner']" spin/>
            </div>
          </div>
          <div key="confirming" v-else>
            <button class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 text-xs leading-4 font-medium rounded text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150" v-if="isConfirming" @click.prevent="isConfirming = false">
              Cancel
            </button>
            <button v-if="isConfirming" class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 text-xs leading-4 rounded bg-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150 text-cardstock-red-500 font-bold">
              Are you sure?
            </button>
          </div>
      </ValidationObserver>
    </template>
  </Mutation>
</template>

<script>
import Mutation from '@/components/Mutation.vue'
import { ValidationObserver, ValidationProvider } from "vee-validate"
import StudentHomeNumberDeleteMutation from '@/mutations/StudentHomeNumberDelete.gql'
import { tz }           from '@/tz'

export default {
  components: {
    Mutation,
    ValidationObserver
  },

  props: {
    student: {
      required: true,
      type: Object
    },
    homeNumber: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      mutation: StudentHomeNumberDeleteMutation,
      isConfirming: false
    }
  },

  computed: {
    variables() {
      return {
        tz: tz(),
        studentId: this.student.id,
        homeNumberId: this.homeNumber.id
      }
    }
  },

  methods: {
    onDone() {
      Bus.$emit('flash-message', {text: 'Number removed from student', type: 'success'})
    },

    onError(e) {
      Bus.$emit('flash-message', {text: e, type: 'error'})
    },

    onSubmit(mutate) {
      if (this.isConfirming) {
        this.isConfirming = false
        mutate()
      } else {
        this.isConfirming = true
      }
    }
  }
}
</script>
